<div class="yc-card-group"
  [class.d-flex]="columnClass">

  @for (item of items; track item) {
    <div class="yc-card-wrapper {{ columnClass }}">
      <div class="yc-card yc-card-payment card"
        [class.with-footer]="item.footerText">
        @if (item.state !== 'zero') {
          <div>
            @if (item.state === 'error') {
              <div>
                <div class="row">
                  <div class="col">
                    <dl>
                      <!-- TITLE  -->
                      <dt class="title">
                        @if (!!item.i18nTitleKey) {
                          <span>
                            @if (!!item.titleTranslationContext) {
                              <yc-i18n
                                [key]="item.i18nTitleKey"
                        [context]="{
                          'titleTranslationContext': item.titleTranslationContext
                        }"
                                [defaultValue]="item.title">
                              </yc-i18n>
                            }
                            @if (!item.titleTranslationContext) {
                              <yc-i18n
                                [key]="item.i18nTitleKey"
                                [defaultValue]="item.title">
                              </yc-i18n>
                            }
                          </span>
                        }
                        @if (!item.i18nTitleKey) {
                          <span>
                            {{ item.title }}
                          </span>
                        }
                      </dt>
                      @if (item.titleDate) {
                        <dd
                          class="sub-title">
                          {{ item.titleDate | ycFormatDate }}
                        </dd>
                      }
                      <dd>
                        @if (!!item.i18nMessageKey) {
                          <span>
                            @if (!!item.messageTranslationContext) {
                              <yc-i18n
                                [key]="item.i18nMessageKey"
                        [context]="{
                          'messageTranslationContext': item.messageTranslationContext
                        }"
                                [defaultValue]="item.message">
                              </yc-i18n>
                            }
                            @if (!item.messageTranslationContext) {
                              <yc-i18n
                                [key]="item.i18nMessageKey"
                                [defaultValue]="item.message">
                              </yc-i18n>
                            }
                          </span>
                        }
                        @if (!item.i18nMessageKey) {
                          <span>
                            {{ item.message }}
                          </span>
                        }
                      </dd>
                      <dd>
                        <!-- LINK  -->
                        @if (item.refreshLinkText) {
                          <div
                            class="col">
                            <yc-button
                              [link]="true"
                              (onClick)="item.refreshAction(item)"
                              size="box">
                              <yc-fa class="me-2"
                          [icon]="item.state === 'error' ?
                            'spinner fa-spin' :
                            ''">
                              </yc-fa>
                              @if (item.i18nRefreshTextKey) {
                                <span>
                                  <yc-i18n
                                    [key]="item.i18nRefreshTextKey"
                                    [defaultValue]="item.refreshLinkText">
                                  </yc-i18n>
                                </span>
                              }
                            </yc-button>
                          </div>
                        }
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            }
            @if (item.state !== 'error') {
              <div>
                <div class="row">
                  <div class="col">
                    <dl>
                      <!-- TITLE  -->
                      <dt class="title">
                        @if (!!item.i18nTitleKey) {
                          <span>
                            @if (!!item.titleTranslationContext) {
                              <yc-i18n
                                [key]="item.i18nTitleKey"
                        [context]="{
                          'titleTranslationContext': item.titleTranslationContext
                        }"
                                [defaultValue]="item.title">
                              </yc-i18n>
                            }
                            @if (!item.titleTranslationContext) {
                              <yc-i18n
                                [key]="item.i18nTitleKey"
                                [defaultValue]="item.title">
                              </yc-i18n>
                            }
                          </span>
                        }
                        @if (!item.i18nTitleKey) {
                          <span>
                            {{ item.title }}
                          </span>
                        }
                      </dt>
                      @if (item.titleDate) {
                        <dd class="sub-title">
                          {{ item.titleDate | ycFormatDate }}
                        </dd>
                      }
                      <dd>
                        @if (!item.amountType) {
                          <div class="amount">
                            {{ item.amount | money }}
                          </div>
                        }
                        @if (item.amountType) {
                          <div class="amount">
                            {{ item.amountType === 'currency' ? (item.amount | money) : (item.amount) }}
                          </div>
                        }
                        <!-- LINK  -->
                        <yc-button
                          [link]="true"
                          [routerLink]="item.link"
                          (onClick)="item.linkAction?.(item)"
                          size="sm">
                          @if (!!item.i18nLinkTextKey) {
                            <span>
                              @if (!!item.linkTranslationContext) {
                                <yc-i18n
                                  [key]="item.i18nLinkTextKey"
                          [context]="{
                            'linkTranslationContext': item.linkTranslationContext
                          }"
                                  [defaultValue]="item.linkText">
                                </yc-i18n>
                              }
                              @if (!item.linkTranslationContext) {
                                <yc-i18n
                                  [key]="item.i18nLinkTextKey"
                                  [defaultValue]="item.linkText">
                                </yc-i18n>
                              }
                            </span>
                          }
                          @if (!item.i18nLinkTextKey) {
                            <span>
                              {{ item.linkText }}
                            </span>
                          }
                          &nbsp;
                          <yc-fa icon="angle-right"></yc-fa>
                        </yc-button>
                      </dd>
                    </dl>
                  </div>
                  @if (item.downloadText) {
                    <div class="col">
                      <yc-button
                        [primary]="true"
                        (onClick)="item.downloadAction(item)"
                        size="box">
                        <yc-fa
                    [icon]="item.state === 'processing' ?
                      'spinner fa-spin' :
                      'download'">
                        </yc-fa>
                        @if (item.i18nDownloadTextKey) {
                          <span>
                            <yc-i18n
                              [key]="item.i18nDownloadTextKey"
                              [defaultValue]="item.downloadText">
                            </yc-i18n>
                          </span>
                        }
                        @if (!item.i18nDownloadTextKey) {
                          <span>
                            {{ item.downloadText }}
                          </span>
                        }
                        @if (item.downloadSubText) {
                          <div>
                            <small>
                              @if (item.i18nDownloadSubTextKey) {
                                <span>
                                  <yc-i18n
                                    [key]="item.i18nDownloadSubTextKey"
                                    [defaultValue]="item.downloadSubText">
                                  </yc-i18n>
                                </span>
                              }
                              @if (!item.i18nDownloadSubTextKey) {
                                <span>
                                  {{ item.downloadSubText }}
                                </span>
                              }
                            </small>
                          </div>
                        }
                      </yc-button>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
        @if (item.state === 'zero') {
          <div >
            <div class="row">
              <div class="col text-center">
                <img class="img-fluid"
                  src="/assets/img/placeholders/no-events-or-opportunities-to-display.svg"
                  [alt]="'common:lblNoResultsFound' | ycI18n: 'No results found'"/>
              </div>
            </div>
            <div class="row">
              <div class="col text-center">
                <dl>
                  <!-- TITLE  -->
                  <dt class="title">
                    @if (!!item.i18nTitleKey) {
                      <span>
                        @if (!!item.titleTranslationContext) {
                          <yc-i18n
                            [key]="item.i18nTitleKey"
                      [context]="{
                        'titleTranslationContext': item.titleTranslationContext
                      }"
                            [defaultValue]="item.title">
                          </yc-i18n>
                        }
                        @if (!item.titleTranslationContext) {
                          <yc-i18n
                            [key]="item.i18nTitleKey"
                            [defaultValue]="item.title">
                          </yc-i18n>
                        }
                      </span>
                    }
                    @if (!item.i18nTitleKey) {
                      <span>
                        {{ item.title }}
                      </span>
                    }
                  </dt>
                  <dd class="sub-title">
                    @if (!!item.i18nMessageKey) {
                      <span>
                        @if (!!item.messageTranslationContext) {
                          <yc-i18n
                            [key]="item.i18nMessageKey"
                      [context]="{
                        'messageTranslationContext': item.messageTranslationContext
                      }"
                            [defaultValue]="item.message">
                          </yc-i18n>
                        }
                        @if (!item.messageTranslationContext) {
                          <yc-i18n
                            [key]="item.i18nMessageKey"
                            [defaultValue]="item.message">
                          </yc-i18n>
                        }
                      </span>
                    }
                    @if (!item.i18nMessageKey) {
                      <span>
                        {{ item.message }}
                      </span>
                    }
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        }
        @if (item.footerText) {
          <div class="footer success">
            @if (!item.footerLink) {
              <span class="yc-line-limit-1 left-text">
                @if (item.i18nFooterTextKey) {
                  <span>
                    <yc-i18n
                      [key]="item.i18nFooterTextKey"
                      [defaultValue]="item.footerText">
                    </yc-i18n>
                  </span>
                }
                @if (!item.i18nFooterTextKey) {
                  <span>
                    {{ item.footerText }}
                  </span>
                }
              </span>
            }
            @if (item.footerLink) {
              <a [routerLink]="item.footerLink" class="yc-line-limit-1 left-text">
                @if (item.i18nFooterTextKey) {
                  <span>
                    <yc-i18n
                      [key]="item.i18nFooterTextKey"
                      [defaultValue]="item.footerText">
                    </yc-i18n>
                  </span>
                }
                @if (!item.i18nFooterTextKey) {
                  <span>
                    {{ item.footerText }}
                  </span>
                }
              </a>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
